module.exports = __webpack_public_path__ + "static/media/Group 106.071f1bef.png";